"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQuarryProgramAddresses = exports.QuarryPDA = void 0;
const quarry_sdk_1 = require("@quarryprotocol/quarry-sdk");
const token_utils_1 = require("@saberhq/token-utils");
const react_1 = require("react");
var QuarryPDA;
(function (QuarryPDA) {
    QuarryPDA["ATA"] = "ATA";
    QuarryPDA["MINE_REWARDER"] = "MINE_REWARDER";
    QuarryPDA["MINE_QUARRY"] = "MINE_QUARRY";
    QuarryPDA["MINE_MINER"] = "MINE_MINER";
    QuarryPDA["MW_MINTER"] = "MW_MINTER";
    QuarryPDA["QUARRY_REGISTRY"] = "QUARRY_REGISTRY";
})(QuarryPDA = exports.QuarryPDA || (exports.QuarryPDA = {}));
const strategies = {
    [QuarryPDA.ATA]: ([mint, owner]) => __awaiter(void 0, void 0, void 0, function* () {
        return yield (0, token_utils_1.getATAAddress)({
            mint,
            owner,
        });
    }),
    [QuarryPDA.MINE_REWARDER]: ([base]) => __awaiter(void 0, void 0, void 0, function* () {
        const [rewarder] = yield (0, quarry_sdk_1.findRewarderAddress)(base);
        return rewarder;
    }),
    [QuarryPDA.MINE_QUARRY]: ([rewarder, token]) => __awaiter(void 0, void 0, void 0, function* () {
        const [quarry] = yield (0, quarry_sdk_1.findQuarryAddress)(rewarder, token);
        return quarry;
    }),
    [QuarryPDA.MINE_MINER]: ([rewarder, token, owner]) => __awaiter(void 0, void 0, void 0, function* () {
        const [quarry] = yield (0, quarry_sdk_1.findQuarryAddress)(rewarder, token);
        const [miner] = yield (0, quarry_sdk_1.findMinerAddress)(quarry, owner);
        return miner;
    }),
    [QuarryPDA.MW_MINTER]: ([mintWrapper, authority]) => __awaiter(void 0, void 0, void 0, function* () {
        const [minter] = yield (0, quarry_sdk_1.findMinterAddress)(mintWrapper, authority);
        return minter;
    }),
    [QuarryPDA.QUARRY_REGISTRY]: ([rewarder]) => __awaiter(void 0, void 0, void 0, function* () {
        const [registry] = yield (0, quarry_sdk_1.findRegistryAddress)(rewarder);
        return registry;
    }),
};
const associationCache = {};
const makeCacheKey = ({ type, path }) => `${type}/${path.map((p) => p.toString()).join(",")}`;
/**
 * Loads and caches program addresses.
 * @param addresses
 * @returns
 */
const useQuarryProgramAddresses = (addresses) => {
    const [keys, setKeys] = (0, react_1.useState)(addresses.map((addr) => {
        var _a;
        if (!addr) {
            return null;
        }
        const cacheKey = makeCacheKey(addr);
        if (associationCache[cacheKey]) {
            return (_a = associationCache[cacheKey]) !== null && _a !== void 0 ? _a : null;
        }
        return null;
    }));
    (0, react_1.useEffect)(() => {
        void (() => __awaiter(void 0, void 0, void 0, function* () {
            setKeys(yield Promise.all(addresses.map((addr) => __awaiter(void 0, void 0, void 0, function* () {
                var _a;
                if (!addr) {
                    return null;
                }
                const cacheKey = makeCacheKey(addr);
                if (associationCache[cacheKey]) {
                    return (_a = associationCache[cacheKey]) !== null && _a !== void 0 ? _a : null;
                }
                const strategy = strategies[addr.type];
                const nextKey = yield strategy(addr.path);
                associationCache[cacheKey] = nextKey;
                return nextKey;
            }))));
        }))();
    }, [addresses]);
    return keys;
};
exports.useQuarryProgramAddresses = useQuarryProgramAddresses;
//# sourceMappingURL=useQuarryProgramAddresses.js.map